package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class TeacherExamClassSectionResponse(
    @SerialName("class_name") val className: String? = null,
    @SerialName("section_name") val sectionName: String? = null
)

@Serializable
data class TeacherExamListItemResponse(
    @SerialName("class_section_id") val classSectionId: String? = null,
    @SerialName("subject_id") val subjectId: String? = null,
    val title: String? = null,
    @SerialName("exam_type") val examType: String? = null,
    @SerialName("max_marks") val maxMarks: Double? = null,
    @SerialName("exam_date") val examDate: String? = null,
    @SerialName("start_date") val startDate: String? = null,
    @SerialName("end_date") val endDate: String? = null,
    val status: String? = null,
    val published: Boolean? = null,
    @SerialName("has_overall_grade") val hasOverallGrade: Boolean? = null,
    @SerialName("has_overall_rank") val hasOverallRank: Boolean? = null,
    @SerialName("has_overall_marks") val hasOverallMarks: Boolean? = null,
    @SerialName("applicable_class_section_ids") val applicableClassSectionIds: List<String>? = null,
    @SerialName("subject_mark_configs") val subjectMarkConfigs: List<Map<String, kotlinx.serialization.json.JsonElement>>? = null,
    val id: String? = null,
    @SerialName("created_by_id") val createdById: String? = null,
    @SerialName("created_by_name") val createdByName: String? = null,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("updated_at") val updatedAt: String? = null,
    @SerialName("exam_id") val examId: String? = null,
    val classes: List<TeacherExamClassSectionResponse>? = null,
    @SerialName("subject_name") val subjectName: String? = null
)

@Serializable
data class TeacherExamCounters(
    val total: Int = 0,
    val scheduled: Int = 0,
    val ongoing: Int = 0,
    val completed: Int = 0,
    val cancelled: Int = 0
)

@Serializable
data class TeacherExamListResponse(
    val count: Int? = null,
    val items: List<TeacherExamListItemResponse>? = null,
    val counters: TeacherExamCounters? = null,
)

@Serializable
data class ExamResultProgressResponse(
    val entered: Int? = null,
    val total: Int? = null,
    val percentage: Double? = null
)

@Serializable
data class TeacherExamResultCountersResponse(
    val total: Int? = null,
    @SerialName("not_started") val notStarted: Int? = null,
    val draft: Int? = null,
    val published: Int? = null
)

@Serializable
data class TeacherExamResultListItemResponse(
    val id: String? = null,
    @SerialName("exam_id") val examId: String? = null,
    val title: String? = null,
    @SerialName("exam_type") val examType: String? = null,
    @SerialName("class_name") val className: String? = null,
    @SerialName("section_name") val sectionName: String? = null,
    val status: String? = null,
    val published: Boolean? = null,
    @SerialName("exam_date") val examDate: String? = null,
    @SerialName("start_date") val startDate: String? = null,
    @SerialName("end_date") val endDate: String? = null,
    @SerialName("max_marks") val maxMarks: Double? = null,
    @SerialName("marks_entered") val marksEntered: ExamResultProgressResponse? = null
)

@Serializable
data class TeacherExamResultListResponse(
    val counters: TeacherExamResultCountersResponse? = null,
    val items: List<TeacherExamResultListItemResponse>? = null
)

@Serializable
data class ExamResponse(
    @SerialName("class_section_id") val classSectionId: String? = null,
    @SerialName("subject_id") val subjectId: String? = null,
    val title: String? = null,
    @SerialName("exam_type") val examType: String? = null,
    @SerialName("max_marks") val maxMarks: Double? = null,
    @SerialName("exam_date") val examDate: String? = null,
    @SerialName("start_date") val startDate: String? = null,
    @SerialName("end_date") val endDate: String? = null,
    val status: String? = null,
    val published: Boolean? = null,
    @SerialName("has_overall_grade") val hasOverallGrade: Boolean? = null,
    @SerialName("has_overall_rank") val hasOverallRank: Boolean? = null,
    @SerialName("has_overall_marks") val hasOverallMarks: Boolean? = null,
    @SerialName("applicable_class_section_ids") val applicableClassSectionIds: List<String>? = null,
    @SerialName("subject_mark_configs") val subjectMarkConfigs: List<Map<String, kotlinx.serialization.json.JsonElement>>? = null,
    val id: String? = null,
    @SerialName("created_by_id") val createdById: String? = null,
    @SerialName("created_by_name") val createdByName: String? = null,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("updated_at") val updatedAt: String? = null
)

@Serializable
data class TeacherExamStatisticsCounters(
    val total: Int = 0,
    val upcoming: Int = 0,
    val ongoing: Int = 0,
    val completed: Int = 0
)

@Serializable
data class TeacherExamStatisticsResponse(
    @SerialName("teacher_id") val teacherId: String? = null,
    @SerialName("teacher_name") val teacherName: String? = null,
    @SerialName("school_id") val schoolId: String? = null,
    @SerialName("academic_year_label") val academicYearLabel: String? = null,
    @SerialName("academic_year_start") val academicYearStart: String? = null,
    @SerialName("academic_year_end") val academicYearEnd: String? = null,
    val counters: TeacherExamStatisticsCounters? = null
)
